export const IconTrustedPartnersModern = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
			<path
				d="M20.3244 2.53276C19.6037 1.81206 18.4315 1.82411 17.7257 2.5595L13.8628 6.58494L4.43563 3.46516L2.4567 5.44412L10.3145 10.2823L6.33847 14.4255L3.78867 14.0069L2 15.7956L5.74859 17.1086L7.06156 20.8571L8.85022 19.0685L8.43161 16.5187L12.5748 12.5427L17.413 20.4004L19.392 18.4215L16.2722 8.99435L20.2976 5.1314C21.033 4.42566 21.0451 3.25349 20.3244 2.53276Z"
				fill="#FFB11A"
			/>
		</svg>
	);
};
